import { css } from 'styled-components'
import { breakpoints } from '../styles'

type cssParams = Parameters<typeof css>
const keys = Object.keys(breakpoints) as Array<keyof typeof breakpoints>

export const respondToWidth = keys.reduce((accumulator, label) => {
    accumulator[label] = (...args: cssParams) => {
        return css`
            @media (min-width: ${breakpoints[label]}) {
                ${css(...args)};
            }
        `
    }
    return accumulator
}, {} as Record<keyof typeof breakpoints, Function>)

export const respondToRetina = keys.reduce((accumulator, label) => {
    accumulator[label] = (...args: cssParams) => {
        return css`
            @media only screen and (-webkit-min-device-pixel-ratio: 2) and (min-width: ${breakpoints[
                    label
                ]}),
                only screen and (min--moz-device-pixel-ratio: 2) and (min-width: ${breakpoints[
                    label
                ]}),
                only screen and (-o-min-device-pixel-ratio: 2/1) and (min-width: ${breakpoints[
                    label
                ]}),
                only screen and (min-device-pixel-ratio: 2) and (min-width: ${breakpoints[
                    label
                ]}),
                only screen and (min-resolution: 192dpi) and (min-width: ${breakpoints[
                    label
                ]}),
                only screen and (min-resolution: 2dppx) and (min-width: ${breakpoints[
                    label
                ]}) {
                ${css(...args)};
            }
        `
    }
    return accumulator
}, {} as Record<keyof typeof breakpoints, Function>)
